
import {PropertyStrategyComponentType} from '@toolify/client/src/modules/tableItems/enum/PropertyStrategyComponentType'
import {$$} from '@vue-macros/reactivity-transform/macros'
import {IChecklistPropertyTypeInterfaces} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/CheckListPropertyTypeStrategy/types/IChecklistPropertyTypeInterfaces'

export function useChecklistValueTypeStrategy() {
  const strategyComponentType = PropertyStrategyComponentType.Dropdown

  const fullValueToText = (value: IChecklistPropertyTypeInterfaces['fullValue']) => {
    if([null, undefined].includes(value)) {
      return ''
    }
    return `${value.completed} / ${value.total}`
  }

  return $$({
    fullValueToText,
    strategyComponentType,
  })
}
